module.exports = __webpack_public_path__ + "img/layer-group.6b21428f.svg";